import React from "react";
import './buttonTheme.css';


interface ButtonThemeProps {
  text: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export default function BtnTheme({ text, onClick, className = "" }: ButtonThemeProps) {
  return (
    <button
      onClick={onClick}
      className={`button-theme ${className}`}
    >
      <span>{text}</span>
    </button>
  );
}
